import { Card } from './Card';

export class Hand {
    cards: Card[] = [];
    index: number;

    constructor (i: number) {
        this.index = i;
    }

    clear () {
        this.cards = [];
    }

    draw (card: Card) {
        card.player = this.index;
        this.cards.push(card);
    }

    discard (index: number, discardIndex?: number, keepPlayer: boolean = false): Card {
        const discarded = this.cards.splice(index, 1)[0];

        if (!keepPlayer) {
            discarded.player = undefined;
        }
        discarded.discardIndex = discardIndex;

        return discarded;
    }
}


// WEBPACK FOOTER //
// ./src/playing-cards/Hand.ts